/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */

// FIX: This is a stop-gap measure until such a time as the creation
// of independent icons can be made or scripted to be made.

import FAQ from '../../../../img/icons/FAQ.svg?name=FAQ';
import LingoAsset from '../../../../img/icons/LingoAsset.svg?name=LingoAsset';
import adaccounts from '../../../../img/icons/ad-accounts.svg?name=adaccounts';
import addperson from '../../../../img/icons/add-person.svg?name=addperson';
import alignbottombuffer from '../../../../img/icons/align-bottom-buffer.svg?name=alignbottombuffer';
import alignbottom from '../../../../img/icons/align-bottom.svg?name=alignbottom';
import aligncenterhorizontal from '../../../../img/icons/align-center-horizontal.svg?name=aligncenterhorizontal';
import aligncentervertical from '../../../../img/icons/align-center-vertical.svg?name=aligncentervertical';
import alignleft from '../../../../img/icons/align-left.svg?name=alignleft';
import alignright from '../../../../img/icons/align-right.svg?name=alignright';
import aligntopbuffer from '../../../../img/icons/align-top-buffer.svg?name=aligntopbuffer';
import aligntop from '../../../../img/icons/align-top.svg?name=aligntop';
import align from '../../../../img/icons/align.svg?name=align';
import arrowback from '../../../../img/icons/arrow-back.svg?name=arrowback';
import arrowforward from '../../../../img/icons/arrow-forward.svg?name=arrowforward';
import arrowright from '../../../../img/icons/arrow-right.svg?name=arrowright';
import audiooff from '../../../../img/icons/audio-off.svg?name=audiooff';
import audioon from '../../../../img/icons/audio-on.svg?name=audioon';
import backarrow from '../../../../img/icons/back-arrow.svg?name=backarrow';
import bargraph from '../../../../img/icons/bar-graph.svg?name=bargraph';
import browser from '../../../../img/icons/browser.svg?name=browser';
import centeralign from '../../../../img/icons/center-align.svg?name=centeralign';
import chainbroken from '../../../../img/icons/chain-broken.svg?name=chainbroken';
import chatoutlined from '../../../../img/icons/chat-outlined.svg?name=chatoutlined';
import chat from '../../../../img/icons/chat.svg?name=chat';
import checkmark from '../../../../img/icons/checkmark.svg?name=checkmark';
import circlefilled from '../../../../img/icons/circle-filled.svg?name=circlefilled';
import circleoutlined from '../../../../img/icons/circle-outlined.svg?name=circleoutlined';
import circle from '../../../../img/icons/circle.svg?name=circle';
import close from '../../../../img/icons/close.svg?name=close';
import colordrop from '../../../../img/icons/color-drop.svg?name=colordrop';
import color from '../../../../img/icons/color.svg?name=color';
import colors from '../../../../img/icons/colors.svg?name=colors';
import contrast from '../../../../img/icons/contrast.svg?name=contrast';
import creativelibrary from '../../../../img/icons/creative-library.svg?name=creativelibrary';
import crop from '../../../../img/icons/crop.svg?name=crop';
import doublekeyframe from '../../../../img/icons/double-keyframe.svg?name=doublekeyframe';
import download from '../../../../img/icons/download.svg?name=download';
import duplicate from '../../../../img/icons/duplicate.svg?name=duplicate';
import editcolor from '../../../../img/icons/edit-color.svg?name=editcolor';
import editpen from '../../../../img/icons/edit-pen.svg?name=editpen';
import elements from '../../../../img/icons/elements.svg?name=elements';
import exclamation from '../../../../img/icons/exclamation.svg?name=exclamation';
import exitsharp from '../../../../img/icons/exit-sharp.svg?name=exitsharp';
import exit from '../../../../img/icons/exit.svg?name=exit';
import filmoutlined from '../../../../img/icons/film-outlined.svg?name=filmoutlined';
import filmstrip from '../../../../img/icons/film-strip.svg?name=filmstrip';
import film from '../../../../img/icons/film.svg?name=film';
import folderadd from '../../../../img/icons/folder-add.svg?name=folderadd';
import folderopened from '../../../../img/icons/folder-opened.svg?name=folderopened';
import folder from '../../../../img/icons/folder.svg?name=folder';
import framenext from '../../../../img/icons/framenext.svg?name=framenext';
import frameprevious from '../../../../img/icons/frameprevious.svg?name=frameprevious';
import imagegallery from '../../../../img/icons/image-gallery.svg?name=imagegallery';
import image from '../../../../img/icons/image.svg?name=image';
import info from '../../../../img/icons/info.svg?name=info';
import interttext from '../../../../img/icons/intert-text.svg?name=interttext';
import keyframe from '../../../../img/icons/keyframe.svg?name=keyframe';
import landscape from '../../../../img/icons/landscape.svg?name=landscape';
import layoutletterbox from '../../../../img/icons/layoutletterbox.svg?name=layoutletterbox';
import layoutsplitvertical2 from '../../../../img/icons/layoutsplitvertical2.svg?name=layoutsplitvertical2';
import layoutsplitvertical3 from '../../../../img/icons/layoutsplitvertical3.svg?name=layoutsplitvertical3';
import layoutstatic from '../../../../img/icons/layoutstatic.svg?name=layoutstatic';
import leftalign from '../../../../img/icons/left-align.svg?name=leftalign';
import lightning from '../../../../img/icons/lightning.svg?name=lightning';
import location from '../../../../img/icons/location.svg?name=location';
import loop from '../../../../img/icons/loop.svg?name=loop';
import magicwand from '../../../../img/icons/magic-wand.svg?name=magicwand';
import maskdestatop from '../../../../img/icons/mask-dest-atop.svg?name=maskdestatop';
import maskdestin from '../../../../img/icons/mask-dest-in.svg?name=maskdestin';
import maskdestout from '../../../../img/icons/mask-dest-out.svg?name=maskdestout';
import maskdestover from '../../../../img/icons/mask-dest-over.svg?name=maskdestover';
import masksrcatop from '../../../../img/icons/mask-src-atop.svg?name=masksrcatop';
import masksrcin from '../../../../img/icons/mask-src-in.svg?name=masksrcin';
import masksrcout from '../../../../img/icons/mask-src-out.svg?name=masksrcout';
import masksrcover from '../../../../img/icons/mask-src-over.svg?name=masksrcover';
import masksrc from '../../../../img/icons/mask-src.svg?name=masksrc';
import maskxor from '../../../../img/icons/mask-xor.svg?name=maskxor';
import menu from '../../../../img/icons/menu.svg?name=menu';
import merge from '../../../../img/icons/merge.svg?name=merge';
import minusperson from '../../../../img/icons/minus-person.svg?name=minusperson';
import minus from '../../../../img/icons/minus.svg?name=minus';
import opacitycontrol from '../../../../img/icons/opacity-control.svg?name=opacitycontrol';
import pankeyframe from '../../../../img/icons/pan-key-frame.svg?name=pankeyframe';
import paste from '../../../../img/icons/paste.svg?name=paste';
import pause from '../../../../img/icons/pause.svg?name=pause';
import pausesharp from '../../../../img/icons/pause-sharp.svg?name=pausesharp';
import pausesimple from '../../../../img/icons/pause-simple.svg?name=pausesimple';
import person from '../../../../img/icons/person.svg?name=person';
import play from '../../../../img/icons/play.svg?name=play';
import playcircle from '../../../../img/icons/playcircle.svg?name=playcircle';
import playfilled from '../../../../img/icons/play-filled.svg?name=playfilled';
import playoutlined from '../../../../img/icons/play-outlined.svg?name=playoutlined';
import playsharp from '../../../../img/icons/play-sharp.svg?name=playsharp';
import playsimple from '../../../../img/icons/play-simple.svg?name=playsimple';
import plus from '../../../../img/icons/plus.svg?name=plus';
import plussharp from '../../../../img/icons/plus-sharp.svg?name=plussharp';
import resize from '../../../../img/icons/resize.svg?name=resize';
import rightalign from '../../../../img/icons/right-align.svg?name=rightalign';
import rocketmodeoff from '../../../../img/icons/rocket-mode-off.svg?name=rocketmodeoff';
import rocketmode from '../../../../img/icons/rocket-mode.svg?name=rocketmode';
import rotate from '../../../../img/icons/rotate.svg?name=rotate';
import savedisk from '../../../../img/icons/save-disk.svg?name=savedisk';
import save from '../../../../img/icons/save.svg?name=save';
import sceneclip from '../../../../img/icons/scene-clip.svg?name=sceneclip';
import sceneempty from '../../../../img/icons/scene-empty.svg?name=sceneempty';
import scissorhorizontal from '../../../../img/icons/scissor-horizontal.svg?name=scissorhorizontal';
import scissorshorizontal from '../../../../img/icons/scissors-horizontal.svg?name=scissorshorizontal';
import scissors from '../../../../img/icons/scissors.svg?name=scissors';
import settings from '../../../../img/icons/settings.svg?name=settings';
import shapes from '../../../../img/icons/shapes.svg?name=shapes';
import smiley from '../../../../img/icons/smiley.svg?name=smiley';
import snaps from '../../../../img/icons/snaps.svg?name=snaps';
import soundoffsharp from '../../../../img/icons/sound-off-sharp.svg?name=soundoffsharp';
import soundoff from '../../../../img/icons/sound-off.svg?name=soundoff';
import soundon from '../../../../img/icons/sound-on.svg?name=soundon';
import soundsharp from '../../../../img/icons/sound-sharp.svg?name=soundsharp';
import sound from '../../../../img/icons/sound.svg?name=sound';
import squareoutlined from '../../../../img/icons/square-outlined.svg?name=squareoutlined';
import square from '../../../../img/icons/square.svg?name=square';
import starfilled from '../../../../img/icons/star-filled.svg?name=starfilled';
import staroulined from '../../../../img/icons/star-oulined.svg?name=staroulined';
import star from '../../../../img/icons/star.svg?name=star';
import supportbasic from '../../../../img/icons/support-basic.svg?name=supportbasic';
import supportheart from '../../../../img/icons/support-heart.svg?name=supportheart';
import support from '../../../../img/icons/support.svg?name=support';
import templateglobal from '../../../../img/icons/template-global.svg?name=templateglobal';
import template from '../../../../img/icons/template.svg?name=template';
import termsandconditions from '../../../../img/icons/terms-and-conditions.svg?name=termsandconditions';
import text from '../../../../img/icons/text.svg?name=text';
import textalignbottom from '../../../../img/icons/text-align-bottom.svg?name=textalignbottom';
import textalignmiddle from '../../../../img/icons/text-align-middle.svg?name=textalignmiddle';
import textaligntop from '../../../../img/icons/text-align-top.svg?name=textaligntop';
import threedotsvertical from '../../../../img/icons/three-dots-vertical.svg?name=threedotsvertical';
import threedotsverticaldouble from '../../../../img/icons/three-dots-vertical-double.svg?name=threedotsverticaldouble';
import timeoulined from '../../../../img/icons/time-oulined.svg?name=timeoulined';
import time from '../../../../img/icons/time.svg?name=time';
import trash from '../../../../img/icons/trash.svg?name=trash';
import trasitionaccelerate from '../../../../img/icons/trasition-accelerate.svg?name=trasitionaccelerate';
import trasitiongradualdecrease from '../../../../img/icons/trasition-gradual-decrease.svg?name=trasitiongradualdecrease';
import trasitiongradualincrease from '../../../../img/icons/trasition-gradual-increase.svg?name=trasitiongradualincrease';
import trasitionjumpcut from '../../../../img/icons/trasition-jump-cut.svg?name=trasitionjumpcut';
import trasitionlinearspeed from '../../../../img/icons/trasition-linear-speed.svg?name=trasitionlinearspeed';
import triangle from '../../../../img/icons/triangle.svg?name=triangle';
import trimclip from '../../../../img/icons/trim-clip.svg?name=trimclip';
import videoplay from '../../../../img/icons/video-play.svg?name=videoplay';
import visibilityhide from '../../../../img/icons/visibility-hide.svg?name=visibilityhide';
import visibilityshow from '../../../../img/icons/visibility-show.svg?name=visibilityshow';
import wandadd from '../../../../img/icons/wand-add.svg?name=mmagic/wand-add';
import wandsubtract from '../../../../img/icons/wand-subtract.svg?name=magic/wand-subtract';
import xaxis from '../../../../img/icons/x-axis.svg?name=xaxis';
import x from '../../../../img/icons/x.svg?name=x';
import yaxis from '../../../../img/icons/y-axis.svg?name=yaxis';
import zoomminus from '../../../../img/icons/zoom-minus.svg?name=zoomminus';
import zoomplus from '../../../../img/icons/zoom-plus.svg?name=zoomplus';
import zoom from '../../../../img/icons/zoom.svg?name=zoom';

export const SVGS = {
  FAQ,
  LingoAsset,
  adaccounts,
  addperson,
  alignbottombuffer,
  alignbottom,
  aligncenterhorizontal,
  aligncentervertical,
  alignleft,
  alignright,
  aligntopbuffer,
  aligntop,
  align,
  arrowback,
  arrowforward,
  arrowright,
  audiooff,
  audioon,
  backarrow,
  bargraph,
  browser,
  centeralign,
  chainbroken,
  chatoutlined,
  chat,
  checkmark,
  circlefilled,
  circleoutlined,
  circle,
  close,
  colordrop,
  color,
  colors,
  contrast,
  creativelibrary,
  crop,
  doublekeyframe,
  download,
  duplicate,
  editcolor,
  editpen,
  elements,
  exclamation,
  exitsharp,
  exit,
  filmoutlined,
  filmstrip,
  film,
  folderadd,
  folderopened,
  folder,
  framenext,
  frameprevious,
  imagegallery,
  image,
  info,
  interttext,
  keyframe,
  landscape,
  layoutletterbox,
  layoutsplitvertical2,
  layoutsplitvertical3,
  layoutstatic,
  leftalign,
  lightning,
  location,
  loop,
  magicwand,
  maskdestatop,
  maskdestin,
  maskdestout,
  maskdestover,
  masksrcatop,
  masksrcin,
  masksrcout,
  masksrcover,
  masksrc,
  maskxor,
  menu,
  merge,
  minusperson,
  minus,
  opacitycontrol,
  pankeyframe,
  paste,
  pause,
  pausesharp,
  pausesimple,
  person,
  play,
  playcircle,
  playfilled,
  playoutlined,
  playsharp,
  playsimple,
  plus,
  plussharp,
  resize,
  rightalign,
  rocketmodeoff,
  rocketmode,
  rotate,
  savedisk,
  save,
  sceneclip,
  sceneempty,
  scissorhorizontal,
  scissorshorizontal,
  scissors,
  settings,
  shapes,
  smiley,
  snaps,
  soundoffsharp,
  soundoff,
  soundon,
  soundsharp,
  sound,
  squareoutlined,
  square,
  starfilled,
  staroulined,
  star,
  supportbasic,
  supportheart,
  support,
  templateglobal,
  template,
  termsandconditions,
  text,
  textalignbottom,
  textalignmiddle,
  textaligntop,
  threedotsvertical,
  threedotsverticaldouble,
  timeoulined,
  time,
  trash,
  trasitionaccelerate,
  trasitiongradualdecrease,
  trasitiongradualincrease,
  trasitionjumpcut,
  trasitionlinearspeed,
  triangle,
  trimclip,
  videoplay,
  visibilityhide,
  visibilityshow,
  wandadd,
  wandsubtract,
  xaxis,
  x,
  yaxis,
  zoomminus,
  zoomplus,
  zoom,
};

export const ICON_SIZE = {
  ONE_FIFTY: 150,
  XXXX_LARGE: 100,
  XXX_LARGE: 50,
  XX_LARGE: 42,
  X_LARGE: 36,
  LARGE: 30,
  REGULAR: 24,
  MEDIUM: 18,
  SMALL: 16,
  X_SMALL: 13,
  XX_SMALL: 8,
};

export const VALID_ICON_SIZES = new Set([
  8,
  13,
  16,
  18,
  24,
  30,
  36,
  42,
  50,
  100,
  150,
]);
